import { styled } from "@mui/material/styles";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

export const StyledAlert = styled(Alert)(() => ({
  width: "100%",
  backgroundColor: "var(--color-error)",
  fontWeight: "var(--font-weight-medium)",
  color: "var(--color-text-inverse)",
  ".MuiAlert-icon": {
    color: "var(--color-text-inverse)",
  },
}));

export const StyledSnackbar = styled(Snackbar)(() => ({
  marginTop: "var(--space-2xl)",
  margin: "var(--space-2xl)",
}));
